import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExportSelectionService {
  private selectedIds = signal<Set<number>>(new Set());

  readonly selectedCount = computed(() => this.selectedIds().size);
  readonly hasSelection = computed(() => this.selectedIds().size > 0);

  getSelectedIds(): number[] {
    return Array.from(this.selectedIds());
  }

  isSelected(id: number): boolean {
    return this.selectedIds().has(id);
  }

  toggle(id: number): void {
    this.selectedIds.update(set => {
      const newSet = new Set(set);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  }

  select(id: number): void {
    this.selectedIds.update(set => {
      const newSet = new Set(set);
      newSet.add(id);
      return newSet;
    });
  }

  deselect(id: number): void {
    this.selectedIds.update(set => {
      const newSet = new Set(set);
      newSet.delete(id);
      return newSet;
    });
  }

  clear(): void {
    this.selectedIds.set(new Set());
  }

  setSelected(ids: number[]): void {
    this.selectedIds.set(new Set(ids));
  }
}
